import Type111 from '../Type111';
import Type112 from '../Type112';
import Type113 from '../Type113';
import Type115 from '../Type115';
import Type116 from '../Type116';
// import Type117 from '../Type117';
import Type118 from '../Type118';
import Type119 from '../Type119';
import Type120 from '../Type120';
import Type121 from '../Type121';
import Type122 from '../Type122';
import Type123 from '../Type123';
import Type126 from '../Type126';
import Type128 from '../Type128';
import Type129 from '../Type129';
import Type130 from '../Type130';
import Type130A from '../Type130A';

const routes = [
  {
    path: '/olympic/admin/classes/1/types/type1',
    name: 'Type 1 (RD) - Type 111',
    component: Type111,
    layout: '/lms',
    exact: true,
  },
  {
    path: '/olympic/admin/classes/1/types/type2',
    name: 'Type 2 (RD) - Type 112',
    component: Type112,
    layout: '/lms',
    exact: true,
  },
  {
    path: '/olympic/admin/classes/1/types/type3A',
    name: 'Type 3 (RD) - Type 113',
    component: Type113,
    layout: '/lms',
    exact: true,
  },
  {
    path: '/olympic/admin/classes/1/types/type4',
    name: 'Type 4 (RD) - Type 115',
    component: Type115,
    layout: '/lms',
    exact: true,
  },
  {
    path: '/olympic/admin/classes/1/types/type5',
    name: 'Type 5 (RD) - Type 116',
    component: Type116,
    layout: '/lms',
    exact: true,
  },
  // {
  //   path: '/olympic/admin/classes/1/types/type117',
  //   name: 'Type 117 (RD) - Type 117',
  //
  //   component: Type117,
  //   layout: '/lms',
  //
  //   exact: true,
  // },
  {
    path: '/olympic/admin/classes/1/types/type7',
    name: 'Type 7 (RD) - Type 118',
    component: Type118,
    layout: '/lms',
    exact: true,
  },
  {
    path: '/olympic/admin/classes/1/types/type8',
    name: 'Type 8 (RD) - Type 119',
    component: Type119,
    layout: '/lms',
    exact: true,
  },
  {
    path: '/olympic/admin/classes/1/types/type9',
    name: 'Type 9 (RD) - Type 120',
    component: Type120,
    layout: '/lms',
    exact: true,
  },
  {
    path: '/olympic/admin/classes/1/types/type10',
    name: 'Type 10 (RD) - Type 121',
    component: Type121,
    layout: '/lms',
    exact: true,
  },
  {
    path: '/olympic/admin/classes/1/types/type11',
    name: 'Type 11 (RD) - Type 122',
    component: Type122,
    layout: '/lms',
    exact: true,
  },
  {
    path: '/olympic/admin/classes/1/types/type12',
    name: 'Type 12 (RD) - Type 123',
    component: Type123,
    layout: '/lms',
    exact: true,
  },
  {
    path: '/olympic/admin/classes/1/types/type15',
    name: 'Type 15 (RD) - Type 126',
    component: Type126,
    layout: '/lms',
    exact: true,
  },
  {
    path: '/olympic/admin/classes/1/types/type17',
    name: 'Type 17 (RD) - Type 128',
    component: Type128,
    layout: '/lms',
    exact: true,
  },
  {
    path: '/olympic/admin/classes/1/types/type18',
    name: 'Type 18 (RD) - Type 129',
    component: Type129,
    layout: '/lms',
    exact: true,
  },
  {
    path: '/olympic/admin/classes/1/types/type19',
    name: 'Type 19 (RD) - Type 130',
    component: Type130,
    layout: '/lms',
    exact: true,
  },
  {
    path: '/olympic/admin/classes/1/types/type20',
    name: 'Type 20 (RD) - Type 130A',
    component: Type130A,
    layout: '/lms',
    exact: true,
  }
];

export default routes;
